import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1 className="about-title">About Math Break Down</h1>

        <section className="about-section">
          <h2>Welcome</h2>
          <p>
            Math Break Down is an interactive educational platform designed to make mathematics
            learning engaging, intuitive, and accessible to students in bachelor programs.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Mission and Approach</h2>
          <p>
            We believe that mathematics should be approachable and enjoyable. Our main goal is to
            enable an active-thinking based learning experience, where students reason their way
            to each answer rather than passively read it. We make this possible through our
            progressive hints, which nudge learners forward one insight at a time, and our
            dynamic solution, which reveals the reasoning step by step so students understand
            not just the "how" but also the "why" behind each concept.
          </p>
        </section>

        <section className="about-section">
          <h2>What We Offer</h2>
          <div className="features-list">
            <div className="feature-item">
              <h3>Excellent Exercises Selection</h3>
              <p>Practice problems ranging from basic to advanced levels with instant feedback.</p>
            </div>
            <div className="feature-item">
              <h3>Interactive Solution</h3>
              <p>Step-by-step, dynamic solutions with progressive hints that stimulates your thinking and Sguide you through each concept at your own pace.</p>
            </div>
            <div className="feature-item">
              <h3>Drawing Canvas</h3>
              <p>Sketch and annotate solutions directly on the canvas with various pen sizes and colors.</p>
            </div>
            <div className="feature-item">
              <h3>Comprehensive Topics</h3>
              <p>Coverage of fundamental to advanced mathematics including integrals, series, and inequalities.</p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Technologies</h2>
          <p>
            Built with React, leveraging modern web technologies to provide a smooth, responsive 
            learning experience across all devices.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
